import React from 'react';
import {Table} from '@/web-components';
import Util from '../../../../shared/util/util';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {getCurrencyCell, getGroupedRowColumns} from '../TimeRegistrationReportTableUtil';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';

export const getDepartmentRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldDefinitions,
	customFieldKeys
) => {
	const getColumns = department =>
		getGroupedRowColumns(
			{
				label: (
					<span>
						{department.noDepartment ? intl.formatMessage({id: 'time_reg_report.no_department'}) : department.name}
					</span>
				),
				actualHours: Util.convertMinutesToFullHour(department.timeRegTotals?.totalTimeRegistered, intl, true),
				billableHours: Util.convertMinutesToFullHour(department.timeRegTotals?.totalBillableRegistered, intl, true),
				nonBillableHours: Util.convertMinutesToFullHour(
					department.timeRegTotals?.totalNonBillableRegistered,
					intl,
					true
				),
				actualBillableValueOfService: getCurrencyCell(department.timeRegTotals?.totalPrice, currency, intl),
				actualCost: getCurrencyCell(department.timeRegTotals?.totalCost, currency, intl),
			},
			customFieldDefinitions
		);

	return (
		<Table.Rows data={data} canExpand={true} loadMore={hasNextPage && fetchMore} {...nextLevelProps}>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noDepartment === true
						? GLOBAL_FILTER_FIELD.NON_DEPARTMENT_TIME_REG
						: GLOBAL_FILTER_FIELD.DEPARTMENT_TIME_REG;
				return (
					<>
						<Table.Row {...tableColumnsProps}>{getColumns(rowData)}</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.departmentId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldDefinitions,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
